const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID?.trim() || 'G-KV5ZET99PK';

type AnalyticsWindow = Window & {
  dataLayer?: unknown[][];
};

export function initialiseGoogleAnalytics() {
  if (!import.meta.env.PROD || !measurementId || !/^G-[A-Z0-9]+$/.test(measurementId)) return;

  const analyticsWindow: AnalyticsWindow = window;
  const dataLayer = analyticsWindow.dataLayer ?? [];
  analyticsWindow.dataLayer = dataLayer;

  const gtag = (...args: unknown[]) => dataLayer.push(args);
  gtag('js', new Date());
  gtag('config', measurementId);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.append(script);
}
